import { getBasePath } from './config';

/** @typedef {'full' | 'icon' | 'mark' | 'icon-duo'} ZaggerLogoVariant */

/**
 * Public URL for a logo file under /logos (respects router basename).
 * @param {string} filename
 */
export function zaggerLogoUrl(filename) {
  const base = getBasePath() || '';
  return `${base}/logos/${filename}`;
}

/**
 * Pick the logo asset filename for theme + variant.
 * @param {ZaggerLogoVariant} variant
 * @param {{ darkMode?: boolean }} [options]
 */
export function resolveZaggerLogoFile(variant, { darkMode = false } = {}) {
  switch (variant) {
    case 'full':
      return darkMode ? 'Full_Color_WhiteTxt.png' : 'Full_Color_BlackTxt.png';
    case 'icon':
      return darkMode ? 'Icon_White.png' : 'Icon_Blue.png';
    case 'icon-duo':
      return 'Icon_2Tone.png';
    case 'mark':
      return darkMode ? 'Z_White.png' : 'Z_Blue.png';
    default:
      return darkMode ? 'Full_Color_WhiteTxt.png' : 'Full_Color_BlackTxt.png';
  }
}

/**
 * @param {ZaggerLogoVariant} variant
 * @param {{ darkMode?: boolean }} [options]
 */
export function resolveZaggerLogoSrc(variant, options = {}) {
  return zaggerLogoUrl(resolveZaggerLogoFile(variant, options));
}

/** Favicon / PWA icon (brand blue). */
export const ZAGGER_FAVICON = zaggerLogoUrl('Icon_Blue.png');
